import { MemberGroupType } from '../types/organizationMembers.type';
import { MembersTableWithTabs } from './MembersTable';

const WorkspaceMembers = () => {
  return (
    <MembersTableWithTabs
      type={MemberGroupType.WORKSPACE}
      showWorkspaces={false}
    />
  );
};

export { WorkspaceMembers };
